import { NavLink } from 'react-router-dom'
import { ScrollArea, Stack, Text, Badge, Group, rem } from '@mantine/core'
import {
  IconDashboard,
  IconServer,
  IconNetwork,
  IconTimeline,
  IconRobot,
  IconSettings,
  IconActivity,
  IconAlertCircle,
  IconBuilding,
  IconDatabase,
  IconSitemap,
  IconKey,
  IconDeviceDesktop,
} from '@tabler/icons-react'
import { useWebSocketStore } from '@/store/websocket'
import classes from './Navbar.module.css'

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: IconDashboard },
  { path: '/services', label: 'Services', icon: IconServer },
  { path: '/nodes', label: 'Nodes', icon: IconNetwork },
  { path: '/gpus', label: 'GPUs', icon: IconDeviceDesktop },
  { path: '/networks', label: 'Networks', icon: IconSitemap },
  { path: '/volumes', label: 'Volumes', icon: IconDatabase },
  { path: '/secrets', label: 'Secrets', icon: IconKey },
  { path: '/traces', label: 'Traces', icon: IconTimeline },
  { path: '/assistant', label: 'AI Assistant', icon: IconRobot },
  { path: '/tenants', label: 'Tenants', icon: IconBuilding },
  { path: '/settings', label: 'Settings', icon: IconSettings },
]

export function Navbar() {
  const connected = useWebSocketStore((state) => state.connected)

  return (
    <ScrollArea>
      <Stack gap="xs" p="md">
        {/* Connection Status */}
        <Group justify="space-between" mb="md">
          <Text size="sm" fw={500}>
            Status
          </Text>
          <Badge
            color={connected ? 'green' : 'red'}
            variant="dot"
            size="sm"
            leftSection={
              connected ? (
                <IconActivity style={{ width: rem(12), height: rem(12) }} />
              ) : (
                <IconAlertCircle style={{ width: rem(12), height: rem(12) }} />
              )
            }
          >
            {connected ? 'Connected' : 'Disconnected'}
          </Badge>
        </Group>

        {/* Navigation Links */}
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${classes.navLink} ${isActive ? classes.active : ''}`
            }
          >
            {({ isActive }) => (
              <Group gap="xs">
                <item.icon
                  style={{ width: rem(20), height: rem(20) }}
                  stroke={1.5}
                  color={isActive ? 'var(--mantine-color-blue-6)' : undefined}
                />
                <Text size="sm" fw={isActive ? 600 : 400}>
                  {item.label}
                </Text>
              </Group>
            )}
          </NavLink>
        ))}
      </Stack>
    </ScrollArea>
  )
}